import { observer } from 'mobx-react-lite';
import { Divider, Header, Icon, Segment, Tab, Table } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { useEffect, useState } from 'react';
import agent from '../../../app/api/agent';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import MetadataHierarchy from './MetadataHierarchy';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { HFCmetadataType } from '../../../app/api/types';

interface Props {
  actId: string;
  title: string;
  elementType: string;
}

export default observer(function MetaData({
  actId,
  title,
  elementType,
}: Props) {
  const {
    commonStore,
    metaDataStore,
    userStore,
    activityStore: { selectedActivity },
    viewStore: { metadata, itemDetails, HFCmetaData },
  } = useStore();
  const [metadataFamily, setMetadataFamily] = useState<{
    parent: any[];
  }>({
    parent: [],
  });
  const [HFCmetadataFamily, setHFCMetadataFamily] = useState<{
    HFCparent: any[];
  }>({
    HFCparent: [],
  });
  const[parentMeta, setParentMeta] = useState<HFCmetadataType[]>([])
  const [ , setOwnerDetails] = useState('');
  let [isLoading, setIsLoading] = useState(true);
  const condition = selectedActivity?.title?.includes('Cutlist');
  const customerName = userStore?.user?.customerName === 'NFAIReport';

  useEffect(() => {
    if (commonStore.hfcCustomerChanges && itemDetails.registerId) {
      (async () => {
        const response = await agent.ReceivingsDeliveries.details(
          itemDetails.registerId,
        );
        setOwnerDetails(response.sender_Details);
      })();
    }
  }, [commonStore.hfcCustomerChanges, itemDetails]);

  useEffect(() => {
    // eslint-disable-next-line
  }, [metadata]);

  const afterAddedFieldsListHandler = (
    data: any[],
    elementCurrentIndex: string,
  ) => {
    let modifiedData: any[] = [];
    // data.sort(function (
    //   a: { elementIndex: number },
    //   b: { elementIndex: number },
    // ) {
    //   return a.elementIndex - b.elementIndex;
    // });
    if (
      userStore?.user?.customerName === 'NFAI' &&
      elementType === 'Category of Reel / Can - Bifurcation'
    ) {
      const element0 = data?.filter((d: any) => d.elementIndex === 0);
      const element77 = data?.filter((d: any) => d.elementIndex === 77);
      const element3 = data?.filter(
        (d: any) => d.elementIndex > 2 && d.elementIndex < 5,
      );
      const element65 = data?.filter((d: any) => d.elementIndex === 65);
      const element79 = data?.filter(
        (d: any) => d.elementIndex > 78 && d.elementIndex < 82,
      );
      const element9 = data?.filter((d: any) => d.elementIndex === 9);
      const elemen83 = data?.filter((d: any) => d.elementIndex === 83);
      const element101 = data?.filter((d: any) => d.elementIndex === 101);
      const element85 = data?.filter(
        (d: any) => d.elementIndex > 83 && d.elementIndex < 87,
      );
      const element87 = data?.filter(
        (d: any) => d.elementIndex > 86 && d.elementIndex < 89,
      );
      const element102 = data?.filter((d: any) => d.elementIndex === 102);
      const element96 = data?.filter((d: any) => d.elementIndex === 96);
      const element89 = data?.filter(
        (d: any) => d.elementIndex > 88 && d.elementIndex < 91,
      );
      const combinedArray = element0.concat(
        element77,
        element3,
        element65,
        element79,
        element9,
        elemen83,
        element101,
        element85,
        element87,
        element102,
        element96,
        element89,
      );

      //removed elements
      const element82 = data?.filter((d: any) => d.elementIndex === 82);
      const element16 = data?.filter((d: any) => d.elementIndex === 16);
      const element18 = data?.filter((d: any) => d.elementIndex === 18);
      const element91 = data?.filter((d: any) => d.elementIndex === 91);

      const removedElements = element82.concat(element16, element18, element91);

      let restElements: any[] = [];
      data?.forEach((d: any) => {
        if (!combinedArray?.includes(d) && !removedElements.includes(d)) {
          restElements.push(d);
        }
      });

      //elements with value
      const withValues: any[] = [];
      restElements?.forEach((d) => {
        if (d.elementValue !== '') {
          withValues.push(d);
        }
      });

      restElements = restElements.filter((el) => !withValues.includes(el));

      modifiedData = combinedArray.concat(withValues, restElements);
    } else {
      modifiedData = [...data];
    }
    return modifiedData?.map((localData: any, index: number) => {
      return {
        ...localData,
        elementCurrentIndex: !!elementCurrentIndex?.length
          ? elementCurrentIndex + `_${index}`
          : `${index}`,
        child: [],
      };
    });
  };

  useEffect(()=>{
    if(HFCmetaData.length > 0){
      setIsLoading(true)
      const childhandler = () =>{
        const metaValue = afterAddedFieldsListHandler(
          HFCmetaData.filter((m) => m.isActive === true &&  m.elementName !== "Title" && m.elementName !== "Print" && m.elementName !=="AssetId"),
          '',
        );
        setHFCMetadataFamily({
          HFCparent: metaValue || [],
        });
      }
      const parenthandler = () =>{
        const filteredValue = afterAddedFieldsListHandler(
          HFCmetaData.filter(m => m.isActive === true && (m.elementName === "Print" || m.elementName === "AssetId")),
          ''
        );
        setParentMeta(filteredValue)
      }
      childhandler()
      parenthandler()
      setIsLoading(false)
    }
    // eslint-disable-next-line
  },[HFCmetaData])

  useEffect(() => {
    const fetchData = async () => {
      if (metadata.length > 0) {
        setIsLoading(true);

        const metadataHandler = ()=>{
          const metadataValue = afterAddedFieldsListHandler(
            metadata.filter((m) => m.enableByDefault === true),
            '',
          );

          setMetadataFamily({
            parent: metadataValue || [],
          });
        }
        if (condition && customerName) {
          try {
            const response = await metaDataStore.CutlistMetadataSummary(
              selectedActivity?.id,
            );

            if (response.length > 0) {
              const metadataValue = afterAddedFieldsListHandler(
                metadata.filter((m) => m.enableByDefault === true),
                '',
              );

              const newElement = {
                elementName: 'Reel Analysis Summary',
                elementValue: response?.replace(/\[|\]/g, ''),
              };

              const updatedMetadata = [...metadataValue, newElement];

              const uniqueData = updatedMetadata.filter(
                (element, index, self) =>
                  self.findIndex(
                    (e) =>
                      e.elementName === element.elementName &&
                      e.elementValue === element.elementValue,
                  ) === index,
              );

              setMetadataFamily({
                parent: uniqueData || [],
              });
            }
            else{
              metadataHandler();
            }
          } catch (error) {
            console.error('Error fetching CutlistMetadataSummary:', error);
          }
        } else {
          metadataHandler();
        }
      }
      setIsLoading(false);
    };

    fetchData();
    // eslint-disable-next-line
  }, [metadata]);

  const recursiveHandler = (
    temp: any[],
    apiChild: any,
    arrayIndex: any[],
    currentIndex: number,
    totalSize: number,
  ) => {
    if (totalSize === currentIndex) {
      return (temp[arrayIndex[currentIndex]].child = apiChild);
    }
    recursiveHandler(
      temp[arrayIndex[currentIndex]]?.child || [],
      apiChild,
      arrayIndex,
      currentIndex + 1,
      totalSize,
    );
    return temp;
  };

  const onClickHandler = async (
    elementId: string,
    elementCurrentIndex: string,
  ) => {
    let params = {
      itemId: actId,
      elementId,
    };
    let result = await agent.viewPage.getChildMetaData(params);
    let data = result?.data;
    if (data?.length) {
      let splitedIndex = elementCurrentIndex?.split('_').map(function (item) {
        return parseInt(item, 10);
      });
      let childData = afterAddedFieldsListHandler(data, elementCurrentIndex);
      let copy = [...metadataFamily.parent];
      await recursiveHandler(
        copy,
        childData,
        splitedIndex,
        0,
        splitedIndex?.length - 1 || 0,
      );
      setMetadataFamily({
        parent: copy,
      });
    }
  };

  return (
    <Tab.Pane
      className={
        commonStore.filterModeZero?.includes('AVLAVF01')
          ? 'component-isDisabled metadata-parent-tab'
          : 'metadata-parent-tab'
      }
    >
      <Segment.Group className={'MetaDataUser'}>
        <Table definition>
          <Table.Body>
            <Table.Row>
              <Table.Cell width={7}>
                <strong
                //Id
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpaneMetadataWorkIdentifier
                        .AVILVPSTPMWIL01 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>
              </Table.Cell>
              <Table.Cell width={7}>
                <span>{actId}</span>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
                <strong
                //Title
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpaneMetadataWorkIdentifier
                        .AVILVPSTPMWIL03 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>
              </Table.Cell>
              <Table.Cell width={7}>
                <span>{title}</span>
              </Table.Cell>
            </Table.Row>
            {/* {commonStore.hfcCustomerChanges && (
              <Table.Row>
                <Table.Cell width={7}>
                  <strong
                  //Owner
                  >
                    Owner
                  </strong>
                </Table.Cell>
                <Table.Cell width={7}>
                  <span>{ownerDetails}</span>
                </Table.Cell>
              </Table.Row>
            )} */}
           {commonStore.hfcCustomerChanges && (
              parentMeta.map(item => (
                <Table.Row key={item.elementName}>
                  <Table.Cell width={7}>
                    <strong>
                      {item.elementName}
                    </strong>
                  </Table.Cell>
                  <Table.Cell width={7}>
                    <span>{item.elementValue}</span>
                  </Table.Cell> 
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table>
        {isLoading ? (
          <Table definition style={{ height: '200px', position: 'relative' }}>
            <Table.Body>
              <LoadingComponent marginTop={'0px'} />
            </Table.Body>
          </Table>
        ) : (
          <>
            <Divider horizontal>
              <Header color="teal" as="h4">
                <Icon name="suitcase" />
                {
                  (
                    userLanguage[0]
                      .AssetsViewItemLevelViewPagesSidebarTabpaneMetadata
                      .AVILVPSTPML03 as any
                  )?.[`${commonStore.language.key}`]
                }
              </Header>
            </Divider>
            <Table definition border="0" cellSpacing="0" cellPadding="0">
              <Table.Body>
                {!commonStore.hfcCustomerChanges ? (
                    metadataFamily?.parent?.map((data) => (
                      <MetadataHierarchy
                        elementDetails={data}
                        onClickHandler={onClickHandler}
                        RaiFirstOpen={metadataFamily?.parent[0]}
                      />
                    ))
                  ) : (
                    HFCmetadataFamily.HFCparent.map((data) => (
                      <MetadataHierarchy
                        elementDetails={data}
                        onClickHandler={onClickHandler}
                        RaiFirstOpen={metadataFamily?.parent[0]}
                      />
                    ))
                  )}
              </Table.Body>
              {!metadataFamily?.parent?.length && !HFCmetadataFamily?.HFCparent?.length &&(
                <Header
                  style={{
                    margin: '0px',
                    padding: '20px',
                    textAlign: 'center',
                  }}
                  //No Metadata found
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpaneMetadata
                        .AVILVPSTPML04 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </Header>
              )}
            </Table>
          </>
        )}
      </Segment.Group>
    </Tab.Pane>
  );
});
